import { css, SerializedStyles } from "@emotion/react";
import { isTelex280Active } from "@utils/userSegment/features";

export function telex280HoverMediaStyledThunk(styles: SerializedStyles) {
  return () => {
    if (isTelex280Active()) {
      return css`
        @media (hover: hover) and (pointer: fine) {
          ${styles}
        }
      `;
    }
    return styles;
  };
}

export function telex280HoverMedia(styles: SerializedStyles) {
  return telex280HoverMediaStyledThunk(styles)();
}
